import { render } from "./PolicyDetail.vue?vue&type=template&id=52fe4320&scoped=true"
import script from "./PolicyDetail.vue?vue&type=script&lang=js"
export * from "./PolicyDetail.vue?vue&type=script&lang=js"

import "./PolicyDetail.vue?vue&type=style&index=0&id=52fe4320&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-52fe4320"

export default script